import React from 'react';
import clsx from 'clsx';
import { Dropdown } from 'semantic-ui-react';
import { useIntl } from 'react-intl';
import { compareByText } from '@/utils/resultsHelper';
import { states } from '@/constants/lifecycle';

const listItem = (dictionary, value, errors, byCode, intl) => {
  const className = errors.includes(dictionary.name) ? 'error' : 'aridhia-dictionary-dropdown';
  const identifier = byCode ? dictionary.code : dictionary.uuid;
  return {
    key: `dictionary_dropdown_item_${identifier}`,
    text: dictionary.name,
    description: dictionary.primary ? intl.formatMessage({ id: 'dictionary.primary' }) : undefined,
    value: identifier,
    active: identifier === value,
    className,
  };
};

const listItems = (dictionaries, value, errors, byCode, intl) => dictionaries.map(
  (dictionary) => listItem(dictionary, value, errors, byCode, intl),
);

const DictionaryDropdown = ({
  byCode,
  className,
  dictionaries,
  disabled,
  errors = [],
  inline,
  message,
  multiple,
  onChange,
  readStatus,
  trigger,
  value,
}) => {
  const intl = useIntl();
  const selection = !inline && !trigger;
  return (
    <Dropdown
      disabled={disabled}
      placeholder={message ? intl.formatMessage({ id: message }) : null}
      onChange={onChange}
      multiple={multiple}
      loading={readStatus === states.PENDING}
      value={value}
      options={listItems(dictionaries, value, errors, byCode, intl).sort(compareByText)}
      className={clsx('aridhia-dictionaries-dropdown max-content-scroll', className)}
      icon={trigger ? null : undefined}
      fluid={selection}
      selection={selection}
      direction={trigger ? 'left' : undefined}
      trigger={trigger}
      inline={inline}
      scrolling
    />
  );
};

export default DictionaryDropdown;
